/** Settings → Plugins: installed and bundled packages, one package and its Install. */
export default {
  // Plugins list and Browse
  installed: "Installed",
  installedPluginsNoun: "installed plugins",
  noPluginsInstalled: "No plugins installed yet.",
  versionUpdateAvailable: "Version {version} · update available",
  browsePlugins: "Browse plugins",
  connections: "Connections",
  pluginsNoun: "plugins",
  noPluginsAvailable: "No plugins available yet.",

  // One package
  version: "Version {version}",
  versionInstalled: "Version {version} · Installed",
  versionOtherInstalled: "Version {version} · version {installed} installed",
  versionUnavailable:
    "Version {version} · This version is no longer available.",
  thisPluginNoun: "this plugin",
  installationStatusNoun: "installation status",
  updating: "Updating…",
  updateTo: "Update to {version}",
  install: "Install",
  installing: "Installing…",
  setUpAgain: "Set up again",
  setUpIn: "Set up in {projects}",
  setUpRequest: "Help me set up the {name} template.",
  setUpAgainRequest:
    "Help me set up the {name} template again. It is already set up in {projects}.",
  export: "Export",
  removing: "Removing…",
  remove: "Remove",
  removeTitle: "Remove {name}?",
  removeKeeps:
    "Removing a plugin keeps your projects, connected accounts, and imported skills.",
  removed:
    "{name} was removed. Your projects, connected accounts, and imported skills stay available.",
  errorNoLongerAvailable: "{name} {version} is no longer available.",
  errorInstall: "Could not reach Denker to set up {name}.",
  errorRemove: "Could not remove {name}.",
  errorUpdate: "Could not update {name}.",
  errorExport: "Could not export {name}.",

  // What a package includes
  apps: "Apps",
  skills: "Skills",
  jobs: "Jobs",
  deliverables: "Deliverables",
  required: "Required",
  optional: "Optional",
  notConnected: "Not connected",
  appReadInBrowser: "Read in your browser",
  appUsesApiKey: "Uses an API key",
  appFallbackBrowser: "or read in your browser",
  appFallbackApiKey: "or use an API key",
  connect: "Connect",
  connectApp: "Connect {name}",
  cadenceDaily: "Daily",
  cadenceWeekdays: "Weekdays",
  cadenceWeekly: "Weekly",
  cadenceBiweekly: "Every two weeks",
  cadenceMonthly: "Monthly",
  scheduleMonthDay: "day {day}",
  triggerStart: "When you start it",
  triggerPick: "When you pick a card on {board}",

  // Projects a package is set up in
  projectsUsingNoun: "projects using this plugin",
} as const;
